import { render, staticRenderFns } from "./Box1.vue?vue&type=template&id=556fa60c&scoped=true&"
import script from "./Box1.vue?vue&type=script&lang=js&"
export * from "./Box1.vue?vue&type=script&lang=js&"
import style0 from "./Box1.vue?vue&type=style&index=0&id=556fa60c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556fa60c",
  null
  
)

export default component.exports